import {ReactNode, CSSProperties} from 'react'
import cn from 'clsx'

import './Box.scss'

export interface BoxProps {
  children: ReactNode
  as?: any
  className?: string
  size?:
    | '5xl'
    | '4xl'
    | '3xl'
    | '2xl'
    | 'xl'
    | 'lg'
    | 'md'
    | 'sm'
    | 'xs'
    | '2xs'
    | '3xs'
    | '4xs'
  weight?: 'regular' | 'medium' | 'demiBold' | 'bold'
  align?: 'center' | 'left' | 'right'
  color?:
    | 'charcoal'
    | 'grey'
    | 'grayer'
    | 'grayer50'
    | 'black'
    | 'black70'
    | 'black50'
    | 'black30'
    | 'white'
    | 'white50'
    | 'white30'
    | 'brown'
    | 'green'
    | 'greenDeep'
    | 'greenLight'
    | 'turquoize'
    | 'turquoizeBright'
    | 'turquoizeDeep'
    | 'redError'
    | 'redError50'
    | 'redHalf'
    | 'dimGrey'
    | 'atmo'
    | 'variation'
  mt?: number
  mr?: number
  mb?: number
  ml?: number
  pt?: number
  pr?: number
  pb?: number
  pl?: number
  fadeIn?: boolean
  style?: CSSProperties
}

export default function Box({
  children,
  as: Component = 'div',
  className,
  size,
  weight,
  align,
  color,
  mt,
  mr,
  mb,
  ml,
  pt,
  pr,
  pb,
  pl,
  fadeIn,
  style,
}: BoxProps) {
  const extendedStyle =
    mt || mr || mb || ml || pt || pr || pb || pl
      ? {
          ...style,
          marginTop: mt,
          marginRight: mr,
          marginBottom: mb,
          marginLeft: ml,
          paddingTop: pt,
          paddingRight: pr,
          paddingBottom: pb,
          paddingLeft: pl,
        }
      : style

  return (
    <Component
      className={cn(
        className,
        'Box',
        size && `Box_size_${size}`,
        weight && `Box_weight_${weight}`,
        align && `Box_align_${align}`,
        color && `Box_color_${color}`,
        fadeIn && `Box_fadeIn`
      )}
      style={extendedStyle}
    >
      {children}
    </Component>
  )
}
